module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nome Fantasia",
      "prop": "nomeFantasia"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.nomeFantasia),
      callback: function($$v) {
        _vm.$set(_vm.form, "nomeFantasia", $$v)
      },
      expression: "form.nomeFantasia"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form.razoesSociais), function(razaoSocial, index) {
    return _c('el-form-item', {
      key: razaoSocial.key,
      attrs: {
        "label": 'Razão Social - ' + (index + 1) + 'ª Opção',
        "prop": 'razoesSociais.' + index + '.nome',
        "rules": {
          required: true,
          message: 'A razão social da empresa é obrigatório',
          trigger: 'blur'
        }
      }
    }, [(_vm.form.razoesSociais.length > 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.removeName(razaoSocial)
        }
      }
    }, [_vm._v("Deletar")]) : _vm._e(), _vm._v(" "), _c('el-input', {
      model: {
        value: (razaoSocial.nome),
        callback: function($$v) {
          _vm.$set(razaoSocial, "nome", $$v)
        },
        expression: "razaoSocial.nome"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addName
    }
  }, [_vm._v("Adicionar Razão Social")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d67a042"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConstituicaoDeEmpresa/PessoaJuridica.vue
// module id = 202
// module chunks = 1